<template>
  <div class="panel">
    <form-title>数据概况</form-title>
    <div class="header">
      <div
        v-for="item in headerItems"
        :key="item.props"
        class="item"
      >
        <span class="label">
          {{ item.name }}
        </span>
        <span class="value">
          <b
            v-if="item.type === 'money'"
            class="unit"
          >￥</b>
          {{ item.type === 'money'? `${panelData[item.props]/100}` :panelData[item.props] }}
        </span>
      </div>
    </div>
    <form-title>机构订单统计</form-title>
    <div class="flex">
      <el-button-group class="switch-btns">
        <el-button
          :type="switchBtnKey === 'agencyTopCountList'?'primary':'default'"
          @click="switchBtnHandler('agencyTopCountList')"
        >
          机构Top15订单量
        </el-button>
        <el-button
          :type="switchBtnKey === 'agencyTopAmountList' ?'primary':'default'"
          @click="switchBtnHandler('agencyTopAmountList')"
        >
          机构Top15金额
        </el-button>
      </el-button-group>
    </div>
    <div id="column" />
    <form-title>支付金额统计</form-title>
    <div class="pay-amount">
      <div class="items">
        <div
          v-for="item in payAmountItems"
          :key="item.name"
          class="item"
        >
          <div class="label">
            {{ item.name }}
          </div>
          <div class="value">
            <b
              v-if="item.type === 'money'"
              class="unit"
            >￥</b>
            {{ item.type === 'money'? `${panelData[item.props]/100}` :panelData[item.props] }}
          </div>
        </div>
      </div>
      <div id="line" />
    </div>
  </div>
</template>

<script>
import { Column, Line } from '@antv/g2plot';
import formTitle from '@/components/common/formTitle.vue';

export default {
  name: 'Home',
  components: {
    formTitle,
  },
  props: {
    panelData: {
      type: Object,
      default: () => ({ agencyTopCountList: [], agencyTopAmountList: [] }),
    },
  },
  data() {
    return {
      headerItems: [
        {
          props: 'buyCount',
          name: '购买人次',
        },
        {
          props: 'payAmount',
          name: '支付金额',
          type: 'money',
        },
        {
          props: 'extractDistributionAmount',
          name: '已提现分销金额',
          type: 'money',
        },
        {
          props: 'waitExtractDistributionAmount',
          name: '已生效分销金额',
          type: 'money',
        },
        {
          props: 'waitValidDistributionAmount',
          name: '待生效分销金额',
          type: 'money',
        },
        {
          props: 'refundAmount',
          name: '退款金额',
          type: 'money',
        },
        {
          props: 'platFormReceiveAmount',
          name: '平台应收',
          type: 'money',
        },
      ],
      payAmountItems: [
        {
          name: '总金额',
          props: 'totalPayAmount',
          type: 'money',
        },
        {
          name: '直播金额',
          props: 'livePayAmount',
          type: 'money',
        },
        {
          name: '视频金额',
          props: 'preJobPayAmount',
          type: 'money',
        },
      ],
      switchBtnKey: 'agencyTopCountList',
      columnPlot: null,
      linePlot: null,
    };
  },
  watch: {
    panelData() {
      this.renderColumn(this.panelData[this.switchBtnKey]);
      this.renderLine(this.panelData.payAmountList);
    },
  },
  methods: {
    // 切换显示机构人员
    switchBtnHandler(val) {
      this.switchBtnKey = val;
      this.renderColumn(this.panelData[this.switchBtnKey]);
    },
    // 渲染柱状图
    renderColumn(data) {
      if (this.columnPlot) {
        this.columnPlot.destroy();
        this.columnPlot = null;
      }
      const alias = this.switchBtnKey === 'agencyTopCountList' ? '购买数量' : '支付金额';
      this.columnPlot = new Column('column', {
        data,
        xField: 'agencyName',
        yField: 'num',
        color: '#FF7223',
        maxColumnWidth: 25,
        columnStyle: {
          radius: [2, 2, 0, 0],
        },
        meta: {
          num: {
            alias,
          },
        },
      });
      this.columnPlot.render();
    },
    // 渲染折线图
    renderLine(data) {
      if (this.linePlot) {
        this.linePlot.destroy();
        this.linePlot = null;
      }
      this.linePlot = new Line('line', {
        data,
        xField: 'periodStr',
        seriesField: 'type',
        yField: 'amount',
        color: ['#FF7223', '#1DD1A1', '#2BADFF'],
        smooth: true,
        point: {
          size: 7,
          shape: 'circle',
          style: {
            stroke: '#fff',
            lineWidth: 1,
          },
        },
      });
      this.linePlot.render();
    },
  },
};
</script>
<style lang="scss" scoped>
.panel {
  .header {
    display: flex;
    overflow-y: auto;
    .item {
      padding: 16px;
      display: flex;
      flex-direction: column;
      background: #f7f7f7;
      margin-right: 15px;
      flex: 1;
      .label {
        color: #979797;
        font-size: 14px;
        font-weight: 500;
      }
      .value {
        font-size: 32px;
        margin-top: 12px;
        font-weight: 800;
        color: $--base-color-main;
        display: flex;
        align-items: center;
        b {
          font-size: 18px;
        }
      }
    }
  }
  .border-bottom {
    border-bottom: 1px solid #ebebeb;
  }
  .switch-btns {
    margin-bottom: 20px;
  }
  #column {
    height: 300px;
  }
  .pay-amount {
    display: flex;
    .items {
      background: #f7f7f7;
      margin-right: 16px;
      min-width: 170px;
      display: flex;
      flex-direction: column;
      padding: 16px;
      .item {
        margin-bottom: 25px;
        .label {
          color: #979797;
          font-size: 14px;
          font-weight: 500;
        }
        .value {
          font-size: 32px;
          margin-top: 12px;
          font-weight: 800;
          color: $--base-color-main;
          display: flex;
          align-items: center;
          b {
            font-size: 18px;
          }
        }
      }
    }
    #line {
      flex: 1;
    }
  }
}
</style>
